'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _tool = require('../../common/tool');

var _tool2 = _interopRequireDefault(_tool);

var _request = require('../../common/request');

var _request2 = _interopRequireDefault(_request);

var _config = require('../../common/config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Buy = /** @class */function () {
    function Buy() {
        this.Timer = null;
        this.headerDom = document.getElementById('kingshiper-header');
        this.buyDom = document.getElementById("buy-box");
        this.paySuccessDom = document.getElementById("payment-success");
        this.payFailDom = document.getElementById("payment-fail");
        this.maskDom = document.getElementById("payment-mask");
        this.wmRequest = new _request2.default();
        this.init();
    }
    Buy.prototype.init = function () {
        this.initPopupClosed();
        this.bindBuyEvent();
        this.bindSuccessReturnEvent();
        this.bindFailReturnEvent();
    };
    Buy.prototype.initPopupClosed = function () {
        var _this = this;
        var that = this;
        window.dataPopupClosed = function (data) {
            // 支付成功
            if (data !== null) {
                that.wmRequest.ajax({
                    url: _config2.default.WC_RECOMMEND,
                    type: 'GET',
                    data: {
                        g_id: g_id
                    }
                }).then(function (res) {
                    _this.maskDom.classList.add('show');
                    if (res.code == 200) {
                        var data_2 = res.data;
                        var str = '';
                        for (var _i = 0, data_1 = data_2; _i < data_1.length; _i++) {
                            var item = data_1[_i];
                            str += "<a href=\"/".concat(item.recommend_goods_detail_url, "\">\n                      <img src=\"").concat(item.recommend_goods_logo, "\" alt=\"\">\n                    </a>");
                        }
                        var recommendImgBox = _tool2.default.$_select(that.paySuccessDom, '.recommend-box');
                        recommendImgBox.insertAdjacentHTML('beforeend', str);
                        that.paySuccessDom.classList.add('show');
                    }
                }).catch(function (err) {
                    console.log('payment error: ', err);
                });
            }
        };
    };
    Buy.prototype.bindBuyEvent = function () {
        var that = this;
        var buyBtns = _tool2.default.$_selectAll(this.buyDom, '.item-buyBtn');
        buyBtns.forEach(function (buyBtn) {
            buyBtn.addEventListener('click', function () {
                if (isLogin == 1) {
                    // 在已登录的情况下，获取version_information的值给Option带出去
                    var version_information_value_1 = '';
                    var splitUrl = location.href.split('&');
                    splitUrl.forEach(function (item) {
                        if (item.includes('version_information')) {
                            version_information_value_1 = item.split('=')[1];
                        }
                    });
                    var buyOption = {
                        'reset': true,
                        'products': [{
                            'path': buyBtn.getAttribute('path')
                        }],
                        "paymentContact": {
                            "email": userEmail
                        },
                        'checkout': true,
                        // 添加一个version_information
                        'tags': {
                            "version_information": version_information_value_1
                        }
                    };
                    fastspring.builder.push(buyOption);
                } else {
                    var hasLoginBtn = document.body.contains(document.getElementsByClassName('kingshiper-header-right-no-login')[0]);
                    if (hasLoginBtn) {
                        var btn = _tool2.default.$_select(that.headerDom, '.kingshiper-header-right-no-login');
                        btn.click();
                    }
                }
            });
        });
    };
    Buy.prototype.bindSuccessReturnEvent = function () {
        // let that = this;
        var paySuccessReturn = _tool2.default.$_select(this.paySuccessDom, '.return-btn');
        // let returnDomNum = Tool.$_select(this.paySuccessDom, '.return-btn span');
        paySuccessReturn.addEventListener('click', function () {
            // that.maskDom.style.display = 'none';
            // that.paySuccessDom.style.display = 'none';
            // returnDomNum.innerHTML = '';
            // let productParams = window.location.pathname.split("/")[1];
            // window.location.href = `/${productParams}/help.html`;
            window.location.href = '/user#order';
            // location.reload();
        });
    };
    Buy.prototype.bindFailReturnEvent = function () {
        var that = this;
        var payFailReturn = _tool2.default.$_select(this.payFailDom, '.return-btn');
        var returnDomNum = _tool2.default.$_select(this.payFailDom, '.return-btn span');
        payFailReturn.addEventListener('click', function () {
            that.payFailDom.style.display = 'none';
            that.maskDom.style.display = 'none';
            returnDomNum.innerHTML = '';
        });
    };
    Buy.prototype.disCountEvent = function (container) {
        var that = this;
        var returnDomNum = _tool2.default.$_select(container, '.return-btn span');
        var returnBtn = _tool2.default.$_select(container, '.return-btn');
        var num = 3;
        returnDomNum.innerHTML = "(".concat(num.toString(), ")");
        if (this.Timer) {
            clearInterval(Number(this.Timer));
        }
        this.Timer = setInterval(function () {
            num--;
            returnDomNum.innerHTML = "(".concat(num.toString(), ")");
            if (num < 0) {
                clearInterval(Number(that.Timer));
                returnDomNum.innerHTML = '';
                returnBtn.click();
            }
        }, 1000);
    };
    return Buy;
}();
exports.default = Buy;